import { render, staticRenderFns } from "./BrowserStreamer.vue?vue&type=template&id=36cef383&"
import script from "./BrowserStreamer.vue?vue&type=script&lang=ts&"
export * from "./BrowserStreamer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports